module.exports = __webpack_public_path__ + "static/media/Asset 3.e0a14ee3.svg";